export class Country {

  countryCode: string;
  countryCodeIso2: string;
  description: string;

  constructor () {
  }

  static parse(data: any): Country {
    return Object.assign(new Country(), {
      countryCode: data.countryCode,
      countryCodeIso2: data.countryCodeIso2,
      description: data.description
    });
  }
}
